<template>
  <div class="content_main">
    <p class="content_normal">We act as Solicitors to ULTIMCRED LIMITED, whom will hereafter refer
      to as Our Client and on whose instruction we now write.</p>
    <br />
    <p class="content_normal">Your loan on our platform (Swiftkash) has been overdue for more than
      two weeks, All efforts to reach you to negotiate the loan proved abortive. Our company
      initially judged that you were unable to repay the loan, and suspected that you try to deceive
      the company and maliciously default on the loan. Note that any moment from now, our company
      reserves the right to shortlist your bank account and BVN for blacklisting and be sent to the
      Bureau to automatically block all your bank accounts.</p>
    <br />
    <p class="content_normal">The company will keep calling more of your contact, friends, and
      family to report the situation to them before swinging to final litigation action.</p>
    <br />
    <p class="content_normal">In order to avoid affecting your reputation, please repay the loan now
      after receiving the notice or contact us. If you have financial difficulties, we can apply for
      a 30% penalty interest reduction for you. After you have completed the repayment, if there is
      still a need for borrowing, you can apply for another loan</p>
    <br />
    <p class="content_normal">After receiving the information, contact our agent for repayment plans
      or reach out to our support team on</p>
    <br />
    <p class="content_normal"> whatsapp: 09010401147</p>
    <p class="content_normal">Email: bill@swiftkash.ng</p>
    <br />
    <p class="content_normal">Therefore, this letter requires you to pay and respond to the mail or
      company immediately.</p>
    <br />
    <p class="content_normal">Note: If you fail to pay, we will use all available methods to seek
      justice, which will obviously make you pay more.</p>
    <br />
    <p class="content_normal">While waiting for your prompt reply, do have the assurance of our best
      regards.</p>
    <br />
    <p class="content_normal">Yours Faithfully.</p>
  </div>
</template>

<script>
export default {
  name: 'swiftM3',
};
</script>

<style lang="stylus" scoped>
px = (1 / 24.75vw);
.content {
  padding: 25 *px 16 *px;
  .content_main{
    line-height: 20px;
    text-indent: 16px;
    margin-top: 16px;
  }
  .content_normal {
    text-align: left;
    text-indent: 16px;
  }
}
</style>
